import router, { get404Router, resetRouter } from "./router";
import { setDocumentTitle } from "@/utils/domUtil";
import { getSsoAuthUrl } from "@/api/sso";
import { getUrlParam } from "@/utils/util";
import store from "@/store";
import storage from "store";
import { ACCESS_TOKEN, TENANT } from "@/store/mutation-types";

router.beforeEach(async (to, from, next) => {
    to.meta && typeof to.meta.title !== "undefined" && setDocumentTitle(`${to.meta.title}`);

    const token = storage.get(ACCESS_TOKEN);
    const ticket = to.query.ticket;
    const tenant = getUrlParam("tenant");
    if (tenant) {
        storage.set(TENANT, tenant)
    }
    // 请求带有 redirect 重定向时，登录自动重定向到该地址
    const redirect = decodeURIComponent(from.query.redirect || to.path);
    //未登录
    if (ticket) {
        store.dispatch("LoginByTicket", ticket).then((res) => {
          if(res.success){
            next({ path: redirect, replace: true });
          }else{
            next()
          }
        }).catch((err)=>{
          console.log(err)
        });
        // const ticketLogin = await store.dispatch("LoginByTicket", ticket);
        // if(ticketLogin.success){
        //     next({ path: redirect, replace: true });
        // }else{
        //     next()
        // }
    } else if (token) {
        if (store.getters.name) {
            const isAdminGroup = store.getters.isAdminGroup
            const isAdmin = store.getters.userInfo.isAdmin === 1 || store.getters.info.isAdmin === 1 || isAdminGroup
            const requiresAdmin = to.path.startsWith('/admin')
            if (requiresAdmin && !isAdmin) {
                next({ path: '/exception/403', replace: true })
                return
            }
            if (to.meta.type && to.meta.type === "app") {
                store.dispatch("AddTab", {
                    name: to.meta.title,
                    code: to.name,
                    url: to.meta.url,
                    icon: to.meta.icon
                }).then(() => {
                    store.dispatch("initWebSocket", store.getters.info).then(() => {
                        next();
                    }).catch((err)=>{
                      console.log(err)
                    });
                }).catch((err)=>{
                  console.log(err)
                });
            } else {
                store.dispatch("initWebSocket", store.getters.info).then(() => {
                    next();
                }).catch((err)=>{
                  console.log(err)
                });
            }
        } else {
            // 根据用户权限信息生成可访问的路由表
            store.dispatch("GetInfo").then(() => {
                store.dispatch("GetAppRouter").then((data) => {
                    resetRouter();
                    router.addRoute(data);
                    router.addRoute(get404Router());
                    if (to.path === redirect) {
                        // set the replace: true so the navigation will not leave a history record
                        next({ ...to, replace: true });
                    } else {
                        // 跳转到目的路由
                        next({ path: redirect });
                    }
                }).catch((err)=>{
                  console.log(err)
                });
                //获取登录用户详情
                store.dispatch("GetContactUserInfo")
                store.dispatch("GetPlatFormConfig")
                store.dispatch("HasIsAdminGroup")
            }).finally(() => {
                // next()
            }).catch((err)=>{
              console.log(err)
            });
        }
    } else {
        if (to.name === 'serviceHall') {
            next()
        } else {
            const param = {
                redirectUrl: location.href,
            };
            getSsoAuthUrl(param).then((res) => {
                if (res.success) {
                    location.href = res.data;
                }
            }).catch((err)=>{
              console.log(err)
            });
        }
    }
});

router.afterEach(() => {
});
